// Copyright (c) 2018 Deere & Company

import RequestDetailsContainer from '../../part-requests/request-details/state-connector';

export default {
    component: RequestDetailsContainer,
    name: 'REQUEST_DETAILS',
    path: 'request-details/:rgaNumber'
};



// WEBPACK FOOTER //
// ./src/routes/part-requests/request-details.js